import { render, staticRenderFns } from "./four.vue?vue&type=template&id=460da2fc&scoped=true"
import script from "./four.vue?vue&type=script&lang=js"
export * from "./four.vue?vue&type=script&lang=js"
import style0 from "./four.vue?vue&type=style&index=0&id=460da2fc&prod&lang=css"
import style1 from "./four.vue?vue&type=style&index=1&id=460da2fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460da2fc",
  null
  
)

export default component.exports